import { AuthService } from "@/services/auth/auth.service";
const _authService = new AuthService();

const loginAction = async (
  { commit },
  { props, callback, callbackError }
): Promise<void> => {
  _authService
    .logIn(props)
    .then(async (response) => {
      _authService.decodeJwt(response.data);

      callback();
      location.reload();
    })
    .catch((error) => callbackError(error));
};
const loginGuestAction = async (
  { commit },
  { token, data, callback, callbackError }
): Promise<void> => {
  _authService
    .loginGuestUser(token, data)
    .then(async (response) => {
      if (response.data.token) {
        _authService.decodeJwt(response.data);
        localStorage.setItem("guestInvitationToken", response.data.token);
        localStorage.setItem(
          "guestInvitationRefreshToken",
          response.data.refresh_token
        );
        callback();
        location.reload();
      } else {
        callbackError(response);
      }
    })
    .catch((error) => callbackError(error));
};

const sendActivationUserEmailAction = async (
  { commit },
  { token, data, callback, callbackError }
) => {
  _authService
    .sendActivationUserEmail(token, data)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => callbackError());
};

const requestPasswordAction = (
  { commit },
  { data, callback, callbackError }
) => {
  _authService
    .requestPassword(data)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      console.log(error.response);
      callbackError(error);
    });
};

const resetPasswordAction = (
  { commit },
  { token, data, callback, callbackError }
) => {
  _authService
    .resetPassword(token, data)
    .then(async () => {
      callback();
    })
    .catch((error) => callbackError(error));
};

const requestPinAction = (
  { commit },
  { data, callback, callbackError }
) => {
  _authService
    .requestPin(data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const authenticationPinAction = (
  { commit },
  { data, callback, callbackError }
) => {
  _authService
    .authenticationPin(data)
    .then((response) => {
      _authService.decodeJwt(response.data);
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const logOutAction = ({ commit }): void => {
  _authService.logOut();
};

const autoLoginMicrosoftAction = (
  { commit },
  { data, callback, callbackError }
) => {
  _authService
    .autoLoginMicrosoft(data)
    .then(async (response) => {
      if (response.data.token) {
        _authService.decodeJwt(response.data);
      }
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const loginGicarAction = async (
  { commit },
  { props, callback, callbackError }
): Promise<void> => {
  _authService
    .loginGicar(props)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error)
    });
};

export default {
  loginAction,
  logOutAction,
  requestPasswordAction,
  resetPasswordAction,
  loginGuestAction,
  sendActivationUserEmailAction,
  requestPinAction,
  authenticationPinAction,
  autoLoginMicrosoftAction,
  loginGicarAction
};
